import React from "react";
import { MenuType } from "../../../types/baseTypes";
import styles from "./FooterMenu.module.scss";
import { CustomLink } from "@/components/CustomLink";

function FooterMenu({
  menu,
  headline,
  extraClass,
}: {
  menu?: MenuType;
  headline: string;
  extraClass?: string;
}) {
  const { items } = menu || {};
  if (!items) return null;
  return (
    <div className={`${styles["footer-menu"]}  ${extraClass}`}>
      {headline && (
        <span className="footer-headline h3 is-block">{headline}</span>
      )}
      {items &&
        Array.isArray(items) &&
        items.map(
          (item, index) =>
            item.url && (
              <CustomLink
                key={index}
                href={item.url}
                target={item.target}
                className={`${styles["menu-item"]} footer-link`}
                id={`menuitem-${index}`}
                disablePrefetch // Disable prefetching for footer links https://trello.com/c/g5k075FS
              >
                {item.title}
              </CustomLink>
            ),
        )}
    </div>
  );
}

export default FooterMenu;
